/**
 * Converts a pixel value (number) to rem, assuming a 16px base font size.
 */
function pxToRem(number, baseNumber = 16) {
  return `${number / baseNumber}rem`;
}

export default pxToRem;
